import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import OffersGrid from '../components/Grid';
import { OfferProvider } from '../store';

import OfferFormLayout from './Form';

export default function OffersGridLayout() {
  return <OfferProvider>
    <OffersGrid />
    <Router>
      <PrivateRoute path={["/offer/offers/add", "/offer/offers/:id"]} component={OfferFormLayout} />
    </Router>
  </OfferProvider>;
}
